import ConfigCombo from './configcombo.vue';
import ConfigComboForm from './configcombo-form.vue';
import RoutesUtils from '../../js/RoutesUtils.js';

var routes = [
    {
        path: '/configcombo/',
        beforeEnter: RoutesUtils.checkAuthPage,
        async: RoutesUtils.checkPermission('configcombo', ['ADMIN'], ConfigCombo),
        keepAlive: true
    },
    {
        path: '/configcombo/new/',
        beforeEnter: RoutesUtils.checkAuthPage,
        async: RoutesUtils.checkPermission('configcombo/new', ['ADMIN'], ConfigComboForm)
    },
    {
        path: '/configcombo/edit/:id/',
        beforeEnter: RoutesUtils.checkAuthPage,
        async: RoutesUtils.checkPermission('configcombo/edit', ['ADMIN'], ConfigComboForm)
    },
    {
        path: '/configcombo/view/:id/',
        beforeEnter: RoutesUtils.checkAuthPage,
        async: RoutesUtils.checkPermission('configcombo/view', ['ADMIN'], ConfigComboForm, { editable: false })
    }
];

export default routes;
